import users from './components/user/reducer'

const system = { users }

export {
  system
}